"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var LotteryDescription = function (_a) {
    var long = _a.long, short = _a.short;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.short },
                " ",
                translateLocale(short)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.long }, translateLocale(long)))));
};
exports.default = LotteryDescription;
